/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import useAppDispatch from "common/hooks/useAppDispatch";
import { configurationSlice } from "store/slices/configuration";

export default function useConfiguration() {
    const dispatch = useAppDispatch();
    return {
        setBaseApiUrl: (baseApiUrl: string) =>
            dispatch(configurationSlice.actions.setBaseApiUrl(baseApiUrl)),
        setClientRegion: (clientRegion: string) =>
            dispatch(configurationSlice.actions.setClientRegion(clientRegion)),
        setClaimDate: (date: Date) => dispatch(configurationSlice.actions.setClaimDate(date)),
        setTenantId: (tenantId: string) =>
            dispatch(configurationSlice.actions.setTenantId(tenantId)),
    };
}
